(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  (function () {
    var sectionId = '{{ section.id }}';
    var bar = document.getElementById('StickyAtcBar-' + sectionId);
    if (!bar) return;

    var mainForm = document.getElementById('BuyButtons-ProductForm-' + sectionId);
    if (!mainForm) return;

    // Show/hide based on main form visibility
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            bar.hidden = true;
            bar.setAttribute('aria-hidden', 'true');
          } else {
            bar.hidden = false;
            bar.setAttribute('aria-hidden', 'false');
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(mainForm);

    // Clicking the sticky bar submits the main product form
    var stickyBtn = bar.querySelector('[data-sticky-atc-section]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var submitBtn = mainForm.querySelector('[type="submit"][name="add"]');
        if (submitBtn) submitBtn.click();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
